import axios from 'axios';
import baseURL, { endPoints } from '../../Config';

const getAccessToken = () => {
    const loginData = JSON.parse(localStorage.getItem('adminUser') || localStorage.getItem('userDetails') || '{}');
    return loginData?.data?.token || loginData?.data?.accessToken;
};

const getJson = async (endpoint) => {
    try {
        const response = await axios.get(`${baseURL + endpoint}`, {
            headers: {
                authorization: `Bearer ${getAccessToken()}`
            }
        });
        return response.data;
    } catch (error) {
        const responseData = error?.response?.data || {};
        const message = responseData?.messages || responseData?.message || responseData?.error || error?.message || 'Request failed';
        const apiError = new Error(message);
        apiError.status = error?.response?.status;
        apiError.code = responseData?.data?.code || responseData?.code;
        throw apiError;
    }
};

const postJson = async (endpoint, payload = {}) => {
    try {
        const response = await axios.post(`${baseURL + endpoint}`, payload, {
            headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${getAccessToken()}`
            }
        });
        return response.data;
    } catch (error) {
        const responseData = error?.response?.data || {};
        const message = responseData?.messages || responseData?.message || responseData?.error || error?.message || 'Request failed';
        const apiError = new Error(message);
        apiError.status = error?.response?.status;
        apiError.code = responseData?.data?.code || responseData?.code;
        throw apiError;
    }
};

const patchJson = async (endpoint, payload = {}) => {
    try {
        const response = await axios.patch(`${baseURL + endpoint}`, payload, {
            headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${getAccessToken()}`
            }
        });
        return response.data;
    } catch (error) {
        const responseData = error?.response?.data || {};
        const message = responseData?.messages || responseData?.message || responseData?.error || error?.message || 'Request failed';
        const apiError = new Error(message);
        apiError.status = error?.response?.status;
        apiError.code = responseData?.data?.code || responseData?.code;
        throw apiError;
    }
};

const buildQueryString = (filters = {}) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        params.append(key, value);
    });

    return params.toString();
};

export const getOperatorDashboardOkrContext = async () => {
    const response = await getJson(endPoints.operatorDashboardOkrContext);
    return response?.data || response || {};
};

export const getOperatorDashboardOkrWeekly = async ({ collaboratorId, cycleId, weekNumber }) => {
    const query = buildQueryString({ collaboratorId, cycleId, weekNumber });
    const response = await getJson(endPoints.operatorDashboardOkrWeekly(query));
    return response?.data || response || {};
};

export const submitOperatorDashboardOkrUpdate = async (entryId) => {
    const response = await patchJson(`${endPoints.okrWeeklyEntries}/${entryId}`, { status: 'submitted' });
    return response?.data || response || {};
};

export const getOperatorDashboardSummary = async ({ collaboratorId, from, to }) => {
    const query = buildQueryString({ collaboratorId, from, to });
    const response = await getJson(endPoints.operatorDashboardSummary(query));
    return response?.data || response || {};
};

export const getOperatorAnomalyOverview = async ({ from, to }) => {
    const query = buildQueryString({ from, to });
    const response = await getJson(endPoints.operatorDashboardAnomalyOverview(query));
    return response?.data || response || {};
};

export const getOperatorReturnTickets = async ({ collaboratorId }) => {
    const query = buildQueryString({ collaboratorId });
    const response = await getJson(endPoints.operatorDashboardReturns(query));
    return response?.data || response || {};
};

export const completeOperatorProductReturn = async (complaintId, payload) => {
    const response = await postJson(endPoints.completeOperatorDashboardProductReturn(complaintId), payload);
    return response?.data || response || {};
};

export const returnOperatorProductToSupport = async (complaintId, payload) => {
    const response = await postJson(endPoints.returnOperatorDashboardProductToSupport(complaintId), payload);
    return response?.data || response || {};
};

export const getOperatorAnomalyReviews = async (filters = {}) => {
    const query = buildQueryString(filters);
    const response = await getJson(endPoints.operatorDashboardAnomalyReviews(query));
    return response?.data || response || {};
};

export const getPendingOperatorAnomalyReviews = async () => {
    const response = await getJson(endPoints.operatorDashboardPendingAnomalyReviews);
    return response?.data || response || {};
};

export const saveOperatorAnomalyReviewDraft = async (payload) => {
    const response = await postJson(endPoints.operatorDashboardAnomalyReviewDraft, payload);
    return response?.data || response || {};
};

export const saveAndSubmitOperatorAnomalyReview = async (payload) => {
    const response = await postJson(endPoints.operatorDashboardAnomalyReviewCreateSubmit, payload);
    return response?.data || response || {};
};

export const submitOperatorAnomalyReview = async (reviewId, payload) => {
    const response = await postJson(endPoints.operatorDashboardAnomalyReviewSubmit(reviewId), payload);
    return response?.data || response || {};
};

export const approveOperatorAnomalyReview = async (reviewId, payload) => {
    const response = await postJson(endPoints.operatorDashboardAnomalyReviewApprove(reviewId), payload);
    return response?.data || response || {};
};

export const rejectOperatorAnomalyReview = async (reviewId, payload) => {
    const response = await postJson(endPoints.operatorDashboardAnomalyReviewReject(reviewId), payload);
    return response?.data || response || {};
};

export const getOperatorSupervision = async (filters = {}) => {
    const response = await axios.get(`${baseURL + endPoints.operatorDashboardOkrContext.replace(/okr-context$/, 'supervision')}?${buildQueryString(filters)}`, {
        headers: { authorization: `Bearer ${getAccessToken()}` }, timeout: 45000
    });
    return response?.data?.data || {};
};
